import { ReactRenderer } from "@tiptap/react";
import { SuggestionOptions } from "@tiptap/suggestion";
import { MentionNodeAttrs } from "@tiptap/extension-mention";
import tippy from "tippy.js";

import MentionList from "@/components/mention/mention-list";

export interface SuggestionItem {
  id: string;
  label: string;
}

export default function createSuggestion(
  options: SuggestionItem[],
): Omit<SuggestionOptions<any, MentionNodeAttrs>, "editor"> {
  return {
    char: "/",
    command: ({ editor, props, range }) => {
      editor.chain().focus().insertContentAt(range, `${props.id}:`).run();
    },
    items: ({ query }) => {
      if (!query) {
        return options;
      }
      return options
        .filter((item) =>
          item.label.toLowerCase().startsWith(query.toLowerCase()),
        )
        .slice(0, 5);
    },

    render: () => {
      let component: any;
      let popup: any;

      return {
        onStart: (props) => {
          component = new ReactRenderer(MentionList, {
            props,
            editor: props.editor,
          });

          if (!props.clientRect) {
            return;
          }

          popup = tippy("body", {
            appendTo: () => document.body,
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: "manual",
            placement: "bottom-start",
          });

          popup[0].setProps({ getReferenceClientRect: props.clientRect });
        },

        onUpdate(props) {
          component.updateProps(props);

          if (!props.clientRect) {
            return;
          }

          popup[0].setProps({
            getReferenceClientRect: props.clientRect,
          });
        },

        onKeyDown(props) {
          if (props.event.key === "Escape") {
            popup[0].hide();

            return true;
          }
          if (props.event.key === "Enter") {
            props.event.stopPropagation();
          }

          return component.ref?.onKeyDown(props);
        },

        onExit() {
          popup[0].destroy();
          component.destroy();
        },
      };
    },
  };
}
